import { createSlice, createSelector } from "@reduxjs/toolkit";
import { HYDRATE } from "next-redux-wrapper";

const initialState = {
  user: {
    roles: [],
  },
  session: {
    token: null,
  },
};

const loggedInUser = createSlice({
  name: "loggedInUser",
  initialState,
  reducers: {
    RESET: () => ({ ...initialState }),
    SET_USER: (state, { payload = {} }) => ({ ...state, user: { ...payload } }),
    SET_SESSION: (state, { payload = {} }) => ({
      ...state,
      session: { ...payload },
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(HYDRATE, (state, action) => {
      if (action.payload.loggedInUser) {
        const { user, session } = action.payload.loggedInUser;
        return {
          ...state,
          user: { ...state.user, ...user },
          session: { ...state.session, ...session },
        };
      }
      return state;
    });
  },
});

export default loggedInUser;

const selectRoles = (state) => state.loggedInUser?.user?.roles;

export const selectHasRole = (role) =>
  createSelector(selectRoles, (roles) => (roles || []).includes(role));

export const loggedInUserActions = loggedInUser.actions;

export const loggedInUserSelector = {
  selectUser: (state) => state.loggedInUser?.user,
  selectSession: (state) => state.loggedInUser?.session,
  selectRoles,
  selectHasRole,
};
